import React from 'react';
import Chapter from '../components/Chapter';
import Scenario from '../components/Scenario';
import Text from '../components/Text';
import Box from '../components/Box';

const Chapter2 = ({
  id,
  trackEvent,
}) => (
  <Chapter
    id={id}
    theme="red"
    title="13:00 uur, dinsdag"
    onEnter={() => trackEvent(id)}
  >
    <Text>Lunchtijd: je checkt je social media.</Text>
    <Scenario
      id="2"
      title="Wat doe je?"
      description="Een goede vriend van je heeft een social score van 350. Gefrustreerd post hij daarover op social media."
      scoreFirst={-20}
      scoreSecond={10}
      buttonTextFirst="Negeren"
      buttonTextSecond="Ontvrienden"
      resultTextFirst="Je score wordt beïnvloed door dat van je vrienden."
      resultTextSecond="Als je vrienden laag scoren, beïnvloedt dat ook jouw score. Ontvrienden levert je 10 punten op."
      onCallback={(title, choice) => trackEvent(id, choice)}
    />
    <Box>
      <h3>Wat is Sesame Credit?</h3>
      <Text>Tot voor kort betaalden veel Chinezen alles cash. Van noodles tot een auto. Er was namelijk geen manier om te controleren of iemand betrouwbaar was.</Text>
      <Text>Nu betaalt iedereen met de apps van Alibaba en maken ze gebruik van Sesame Credit. Die functie geeft mensen een score op basis van hun financiële betrouwbaarheid.</Text>
    </Box>
  </Chapter>
);

export default Chapter2;



// WEBPACK FOOTER //
// ./src/chapters/Chapter2.js